// Listado de terapias que se muestran de forma informativa en la pantalla
// pública de terapias. Más adelante esta información podrá cargarse desde el
// panel administrador; por ahora se mantiene aquí como fuente única.
export const therapyList = [
  {
    id: 'fonoaudiologia',
    title: 'Fonoaudiología',
    description:
      'Espacio terapéutico para rehabilitar la comunicación, el lenguaje y la deglución, optimizando la funcionalidad y la calidad de vida de los jóvenes en todos sus entornos.',
  },
  {
    id: 'integracion-sensorial',
    title: 'Integración Sensorial',
    description:
      'Intervención terapéutica para procesar e integrar estímulos sensoriales, mejorando la participación y el desempeño ocupacional en las actividades cotidianas de la persona.',
  },
  {
    id: 'terapia-ocupacional',
    title: 'Terapia Ocupacional',
    description:
      'Disciplina sanitaria que promueve la salud y el bienestar a través de la ocupación significativa, facilitando la autonomía y la participación activa en la vida diaria.',
  },
  {
    id: 'psicologia',
    title: 'Psicología',
    description:
      'Proceso de acompañamiento profesional para comprender y gestionar las emociones, pensamientos y conductas, fomentando el desarrollo personal y el equilibrio mental.',
  },
  {
    id: 'modificacion-conducta',
    title: 'Modificación de Conducta',
    description:
      'Enfoque terapéutico centrado en la modificación de conductas observables, mediante técnicas de aprendizaje para mejorar la adaptación y el funcionamiento del individuo.',
  },
  {
    id: 'estimulacion-temprana',
    title: 'Estimulación Temprana',
    description:
      'Servicio sistemático de intervenciones diseñado para favorecer y acelerar el desarrollo integral del niño en la etapa crucial de los primeros años de vida.',
  },
  {
    id: 'terapia-familiar',
    title: 'Terapia Familiar',
    description:
      'Proceso de apoyo y guía profesional a la familia, fortaleciendo sus capacidades para afrontar desafíos y promover un desarrollo saludable de todos sus miembros.',
  },
];
